import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import * as CandidateService from "@app/services/CandidateService";
import {ResponseCode} from "@app/constants/Common";
import {showSuccessMessageSaveData} from "@pages/candidate/Common";
import {alertMessage} from "@app/constants/Messages";
import {DateUtils} from "@app/utils/DateUtils";
import {convertVNDateTimeToDate} from "@app/utils/DateTimeUtils";

const CandidateDVTJCUVExtendExpiryTimeModal = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const [client, setClient] = useState({});
    const [numMonths, setNumMonths] = useState('');
    const [originExpiryDate, setOriginExpiryDate] = useState('');

    const {dvtjcuv, isShow, onClose} = props

    const onUpdateExpiryTime = async () => {
        setIsLoading(true)
        const res = await CandidateService.requestUpdateCandidateDVTJCUV({
            id: client.id,
            has_update_expiry_time: true,
            candidate_id: client.candidate_id,
            expiry_date_time: client.expiry_date_time,
            service_use_month: client.service_use_month + Number(numMonths)
        })
        setIsLoading(false)
        if (res.sts_code === ResponseCode.SUCCESS) {
            showSuccessMessageSaveData(res.sts_code)
            onClose(true)
        } else {
            alertMessage(res.sts_code, true, true)
        }
    };

    const onCloseModal = () => {
        onClose()
    }

    const addMonthFromCurrentDate = (num) => {
        if (num <= 0) {
            client.expiry_date_time = originExpiryDate
        } else {
            // const currentDate = client.expiry_date_time ? client.expiry_date_time : new Date();
            let fromDate = DateUtils.convertVNDateToDate(originExpiryDate)
            if (fromDate < new Date()) {
                fromDate = new Date()
            }
            client.expiry_date_time = DateUtils.addMonths(fromDate, num)
            client.expiry_date_time = client.expiry_date_time.toISOString().slice(0, 10)
        }

        setClient({...client})
    }

    const onChangeNumMonths = (event) => {
        const num = Number(event.target.value)
        if (num >= 0) {
            setNumMonths(event.target.value)
            addMonthFromCurrentDate(num)
        }
    }
    useEffect(() => {
        const dv = {...dvtjcuv}
        setOriginExpiryDate(dv.expiry_date_time)
        // dv.expiry_date_time = convertVNDateTimeToDate(dv.expiry_date_time)
        // dv.expiry_date_time = dv.expiry_date_time.toISOString().slice(0, 10)
        setClient(dv)
    },[])

    return (
        <>
            <Modal show={isShow}
                   size={'lg'}
                   onHide={() => onCloseModal()}
                   animation={false} style={{zIndex: 3001}}>
                <Modal.Header>
                    <Modal.Title>Gia hạn lần SDDV: {client.id}</Modal.Title>
                    <Button variant='secondary' onClick={() => onCloseModal()}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    <div className='form-group'>
                        <label className={'w-100'}>Số tháng</label>
                        <div className={'row'}>
                            <div className='col-sm-6 pr-0'>
                                <input className='form-control' type={'number'}
                                       placeholder={'Nhập số tháng'}
                                       value={numMonths}
                                       onChange={event => onChangeNumMonths(event)}
                                />
                            </div>
                            <div className={'col-sm-6'}>
                                <input type={'date'} className='form-control'
                                       disabled
                                       value={client.expiry_date_time}/>
                            </div>
                        </div>
                    </div>
                </Modal.Body>

                <Modal.Footer>
                    <button type='button'
                            className='btn btn-primary'
                            onClick={() => onUpdateExpiryTime()}>
                        Save
                    </button>
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default CandidateDVTJCUVExtendExpiryTimeModal;
